import apiClient, { getCurrentUserId } from './apiClient';

const fetchProducts = async () => {
  try {
    const response = await apiClient.post('/products_list', { user_id: getCurrentUserId() });
    return response.data;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

export const deleteProduct = async (productId) => {
  try {
    await apiClient.delete(`/products/${productId}`);
  } catch (error) {
    throw new Error(`Failed to delete product with ID ${productId}: ${error.message}`);
  }
};

export { fetchProducts };
